import { Box, Container, Typography } from "@mui/material";
import { useEffect } from "react";
import MenuService from "../../components/Menu/menuService";

const CookiePolicy = () => {
  const boldWeight = 700;

  const { selectPage } = MenuService();

  useEffect(() => {
    selectPage("cookie-policy");
  }, []);

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          paddingTop: "50px",
          paddingBottom: "50px",
          minHeight: { xs: "200px", md: "500px" },
        }}
      >
        <Box fontWeight={boldWeight} marginBottom="2rem">
          <Typography
            sx={{ fontWeight: boldWeight, fontSize: "1.5rem !important" }}
          >
            Collecticos Cookie Policy
          </Typography>
        </Box>

        <Typography>
          Collecticos <strong>does not use cookies</strong> or track your
          activity in any way. Your privacy is important to us, and we do not
          collect or store any personal data through cookies or similar
          technologies.
        </Typography>
      </Box>
    </Container>
  );
};

export default CookiePolicy;
